var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('el-menu', {
    staticClass: "el-menu-demo",
    attrs: {
      "active-text-color": "#309af2",
      "default-active": _vm.activeMenu,
      "mode": "horizontal"
    },
    on: {
      "select": _vm.handleSelect
    }
  }, [_vm._l(_vm.routes, function (route) {
    return [_c('nav-menu-item', {
      key: route.path,
      staticClass: "menu-item-box",
      attrs: {
        "item": route,
        "base-path": route.path
      }
    })];
  })], 2);
};
var staticRenderFns = [];
export { render, staticRenderFns };